module.exports = __webpack_public_path__ + "static/how-to-cover-ccb001be9040963a45d2177f15dbbb2a.png";